import React, { useState } from "react";

const OrderComponent = () => {
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);

    // const headers = new Headers();
    // if (token) {
    //   headers.set("Authorization", `Bearer ${token}`);
    // }
    // headers.set("Content-Type", "application/json");

    try {
      const response = await fetch("https://sandbox.octopos.rs/api/weborder", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer XMSaQ0GSftO+Oe5nMXZPcIWfEDejrdo/LY3DJSJJEXZIWjO+FZlKWITDWAHsizpRQdJvRahMvBvDZm+Gr3J7UecPCYnhI92BeY6Q4I6/SxhHeh39y1l/AeWHpTxn6WzRlJoFEzm1athizbD56M/s7HSeNJeGt+OMBkbhJVj2olEmTLu5sp9MuQA0XoMBcH7b",
        },
        body: JSON.stringify({
          Items: [
            {
              GroupName: "Sokovi",
              ProductCode: "S001",
              ProductName: "Coca Cola 0.33",
              UnitMeasure: "kom",
              TaxLabel: "Ж",
              Quantity: 2,
              Price: 150.0,
            },
          ],
          ExternalId: "octopos-001",
          Payments: [
            {
              FiscalPaymentTypeId: 4,
              Amount: 300.0,
            },
          ],
          FiscalReceiptData: {
            ReturnTextualRepresentation: true,
            LineWidth: 46,
            Jmbg: "1122334455",
          },
        }),
      });

      //   const data = await response.json();
      setResponseData(response); // Store the response data
      console.log(response);
    } catch (err) {
      setError("Error: " + err.message); // Catch any errors and display them
      console.error("Error:", err);
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  return (
    <div>
      <button onClick={handleSubmit} disabled={loading}>
        {loading ? "Submitting..." : "Submit Order"}
      </button>

      {responseData && (
        <div>
          <h3>Response Data:</h3>
          <pre>{JSON.stringify(responseData, null, 2)}</pre>
        </div>
      )}

      {error && (
        <div style={{ color: "red" }}>
          <h3>Error:</h3>
          <pre>{error}</pre>
        </div>
      )}
    </div>
  );
};

export default OrderComponent;
